import { fetchApi } from '@/services/api-client';

export const AI_SETTINGS_PATH = '/ai-settings';
export const AI_PLAYGROUND_PATH = '/ai/playground';

// Never includes the (encrypted) key itself — just whether one is stored.
export type AiSettingsView = {
  hasKey: boolean;
  enabled: boolean;
  defaultModel: string;
  monthlyBudgetUsd: number;
  updatedAt: string | null;
  month: { spendUsd: number; requests: number; errors: number };
};

export type AiModelOption = { value: string; label: string; priced: boolean };

export type AiMonthTotals = {
  month: string;
  spendUsd: number;
  requests: number;
  byFeature: { feature: string; model: string; requests: number; spendUsd: number }[];
};

export type PlaygroundRequest = { text: string; subjects?: string[]; dryRun?: boolean };

export type PlaygroundDryRunResponse = { redacted: string; people: number; contacts: number };

export type PlaygroundResponse = {
  text: string;
  redacted: { instructions: string; input: { role: string; content: string }[]; reply: string };
  usage: { inputTokens: number; cachedTokens: number; outputTokens: number; costUsd: number };
  unmatchedTokens: number;
  model: string;
};

export const aiApi = {
  getSettings: () => fetchApi<AiSettingsView>(AI_SETTINGS_PATH),
  getModels: () => fetchApi<AiModelOption[]>(`${AI_SETTINGS_PATH}/models`),
  getUsage: (month?: string) => fetchApi<AiMonthTotals>(`${AI_SETTINGS_PATH}/usage${month ? `?month=${month}` : ''}`),
  setKey: (apiKey: string) =>
    fetchApi<{ ok: true }>(`${AI_SETTINGS_PATH}/key`, { method: 'PUT', body: JSON.stringify({ apiKey }) }),
  clearKey: () => fetchApi<{ ok: true }>(`${AI_SETTINGS_PATH}/key`, { method: 'DELETE' }),
  setEnabled: (enabled: boolean) =>
    fetchApi<{ ok: true }>(`${AI_SETTINGS_PATH}/enabled`, { method: 'PUT', body: JSON.stringify({ enabled }) }),
  setDefaults: (payload: { defaultModel: string; monthlyBudgetUsd: number }) =>
    fetchApi<{ ok: true }>(`${AI_SETTINGS_PATH}/defaults`, { method: 'PUT', body: JSON.stringify(payload) }),
  playground: (payload: PlaygroundRequest) =>
    fetchApi<PlaygroundDryRunResponse | PlaygroundResponse>(AI_PLAYGROUND_PATH, {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
};
